import { BasicRegisterDialogProperties } from "@goodgamestudios/core";
import { CommonDialogNames } from "@goodgamestudios/core";
import { SimpleCommand } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";

export class Poker2ShowRegisterDialogCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        var registerProperties: BasicRegisterDialogProperties = new BasicRegisterDialogProperties();
        registerProperties.username = Poker2Model.userData.userName;
        this.layoutManager.showDialog(CommonDialogNames.RegisterDialog_NAME, new BasicRegisterDialogProperties());
    }

    private get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
}
classImplementsInterfaces(Poker2ShowRegisterDialogCommand, "ISimpleCommand");
